import React from "react";
import ReceiptPDFDocument from "components/finance/ReceiptPDFDocument";

const ReceiptPDF = ({ transactionData, type, paymentHistory, organizationLogoSrc }) => {
  return (
    <ReceiptPDFDocument
      transactionData={transactionData}
      type={type}
      paymentHistory={paymentHistory}
      scope="organization"
      organizationLogoSrc={organizationLogoSrc}
    />
  );
};

export default ReceiptPDF;
